import { ReactElement } from 'react';
import { LeftButtonSt, RightButtonSt } from './MediaGalleryControls.css';
import { ChevronLeft, ChevronRight } from '@heycar-uikit/icons';

interface IMediaGalleryControlsProps {
  fullscreen?: boolean;
  disabled?: boolean;
  offset?: number;
  handleBackClick?: () => void;
  last?: number;
  handleNextClick?: () => void;
  withBackground?: boolean;
}

const MediaGalleryControls = ({
  fullscreen,
  disabled,
  offset,
  handleBackClick,
  last,
  handleNextClick,
  withBackground,
}: IMediaGalleryControlsProps): ReactElement => {
  const onPreviousClick = e => {
    e.preventDefault();
    e.stopPropagation();
    handleBackClick();
  };

  const onNextClick = e => {
    e.preventDefault();
    e.stopPropagation();
    handleNextClick();
  };

  return (
    !disabled && (
      <>
        <LeftButtonSt
          visible={offset > 0}
          onClick={onPreviousClick}
          data-qa="image-gallery-left-button"
          withBackground={withBackground}
          fullscreen={fullscreen}
        >
          <ChevronLeft />
        </LeftButtonSt>
        <RightButtonSt
          visible={offset < last}
          onClick={onNextClick}
          data-qa="image-gallery-right-button"
          withBackground={withBackground}
          fullscreen={fullscreen}
        >
          <ChevronRight />
        </RightButtonSt>
      </>
    )
  );
};

export { MediaGalleryControls };
